import React from 'react'
import { Navigate } from 'react-router-dom'
import { getSessionMainId } from './utils/getCookie';

function ProtectedRoute({ children }) {
    const userLoggedIn = getSessionMainId();

    return userLoggedIn ? children : <Navigate to="/login" />;
}
export default ProtectedRoute;